export const ACTION_SET_ALERT_SUCCESS = "ACTION_SET_ALERT_SUCCESS"
export const ACTION_SET_ALERT_SUCCESS_TEXT = "ACTION_SET_ALERT_SUCCESS_TEXT"
export const ACTION_SET_ALERT_DANGER = "ACTION_SET_ALERT_DANGER"
export const ACTION_SET_ALERT_DANGER_TEXT = "ACTION_SET_ALERT_DANGER_TEXT"
export const ACTION_SET_BROWSER_HISTORY = "ACTION_SET_BROWSER_HISTORY"
export const ACTION_SET_NOTIFICATIONS = "ACTION_SET_NOTIFICATIONS"
export const ACTION_SET_FIRST_LOAD_NOTIFICATION = "ACTION_SET_FIRST_LOAD_NOTIFICATION"
export const ACTION_NOTIFICATION_STATUS = "ACTION_NOTIFICATION_STATUS"
export const ACTION_SET_AMOUNT_NOTIFICATION = "ACTION_SET_AMOUNT_NOTIFICATION"